export function YDivider() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="78"
      viewBox="0 0 7 78"
      fill="none"
    >
      <path
        d="M3.57617 77.6667C5.04893 77.6667 6.24284 76.4728 6.24284 75C6.24284 73.5272 5.04893 72.3333 3.57617 72.3333C2.10341 72.3333 0.909505 73.5272 0.909505 75C0.909505 76.4728 2.10341 77.6667 3.57617 77.6667ZM4.07617 5L6.46292 -1.26184e-07L0.689417 1.26184e-07L3.07617 5L4.07617 5ZM4.07617 75L4.07617 72.9167L3.07617 72.9167L3.07617 75L4.07617 75ZM4.07617 68.75L4.07617 64.5833L3.07617 64.5833L3.07617 68.75L4.07617 68.75ZM4.07617 60.4167L4.07617 56.25L3.07617 56.25L3.07617 60.4167L4.07617 60.4167ZM4.07617 52.0833L4.07617 47.9167L3.07617 47.9167L3.07617 52.0833L4.07617 52.0833ZM4.07617 43.75L4.07617 39.5833L3.07617 39.5833L3.07617 43.75L4.07617 43.75ZM4.07617 35.4167L4.07617 31.25L3.07617 31.25L3.07617 35.4167L4.07617 35.4167ZM4.07617 27.0833L4.07617 22.9167L3.07617 22.9167L3.07617 27.0833L4.07617 27.0833ZM4.07617 18.75L4.07617 14.5833L3.07617 14.5833L3.07617 18.75L4.07617 18.75ZM4.07617 10.4167L4.07617 6.24999L3.07617 6.24999L3.07617 10.4167L4.07617 10.4167Z"
        fill="#838278"
      />
    </svg>
  )
}
